<ion-content class="stage-wrap theme-{{userService.theme}}">
    <app-learning-journey-skeleton-template
            *ngIf="isLoading"></app-learning-journey-skeleton-template>

    <div [ngSwitch]="pageData.stage.details.type"
         [class]="pageData.stage.details.type"
         [ngClass]="{'footer-block': isSaveList || isSaveProgram}"
         *ngIf="pageData !== null">
        <app-learning-journey-text-template
                *ngSwitchCase="'text'"
                [stage]="pageData.stage">
        </app-learning-journey-text-template>

        <ng-container *ngSwitchCase="'list'">
            <ion-content class="theme-{{userService.theme}}">
                <app-learning-journey-list-template class="page-box journey-box-shadow"
                        (doChangeSaveButton)="onChangeListSaveButton($event)"
                        [stage]="pageData.stage"
                        [list]="pageData.details.list">
                </app-learning-journey-list-template>
            </ion-content>
            <ion-footer *ngIf="isSaveList" class="swiper-no-swiping">
                <app-footer (saveEvent)="onSaveList()" [backButton]="true" [saveButton]="true"></app-footer>
            </ion-footer>
        </ng-container>

        <ng-container *ngSwitchCase="'program'">
            <ion-content>
                <app-learning-journey-programm-template
                        (doChangeSaveButton)="onChangeProgramSaveButton($event)"
                        [stage]="pageData.stage"
                        [programDelegate]="pageData.details.program_delegate"
                        [saveForm]="saveForm"
                        [level]="'learner'">
                </app-learning-journey-programm-template>
            </ion-content>
            <ion-footer *ngIf="isSaveProgram" class="swiper-no-swiping">
                <app-footer (saveEvent)="onSave()" [backButton]="true" [saveButton]="true"></app-footer>
            </ion-footer>
        </ng-container>
    </div>

</ion-content>
